import { SYSTEM_HELP } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import HelpPanelQuery, {
	type HelpPanelQuery$data,
	type HelpPanelQuery$variables,
} from './__generated__/HelpPanelQuery.graphql.ts';

export const preloadHelpMenu = () => {
	return waitForAllReturnWhenError([
		preloadWebItemLocation({ location: SYSTEM_HELP }),
		query<HelpPanelQuery$data, HelpPanelQuery$variables>({ query: HelpPanelQuery }),
	]);
};
